import { TComplimentaryProductsState } from 'pages/calculation/types/complimentary-products-state.type';
import { TCheckedType } from 'pages/common/types';
import { getIsCheckedProducts } from './get-is-checked-products.helper';

export const getTotalCostComplimentaryProducts = ({
  complimentaryProducts,
  checkedProducts,
}: {
  complimentaryProducts: TComplimentaryProductsState;
  checkedProducts: [] | TCheckedType;
}) =>
  Object.values(complimentaryProducts).reduce((total, product) => {
    const isProductChecked = getIsCheckedProducts({ checkedProducts, productId: product.productId });

    const salesPrice =
      isProductChecked && product.salesPriceValueInConsumerUnitValue !== null
        ? product.salesPriceValueInConsumerUnitValue
        : 0;
    const quantity = product.total.requiredQuantity;
    return total + salesPrice * quantity;
  }, 0);
